/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FolderCto } from '../../models/folder-cto';

export interface GetFolders$Json$Params {
  CompanyName?: string;
  CompanyGuid?: string;
  CompanyId?: number;
  ApiCompanyId?: string;
  FolderGuid?: string;
  FolderName?: string;
}

export function getFolders$Json(http: HttpClient, rootUrl: string, params?: GetFolders$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FolderCto>>> {
  const rb = new RequestBuilder(rootUrl, getFolders$Json.PATH, 'get');
  if (params) {
    rb.query('CompanyName', params.CompanyName, {});
    rb.query('CompanyGuid', params.CompanyGuid, {});
    rb.query('CompanyId', params.CompanyId, {});
    rb.query('ApiCompanyId', params.ApiCompanyId, {});
    rb.query('FolderGuid', params.FolderGuid, {});
    rb.query('FolderName', params.FolderName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FolderCto>>;
    })
  );
}

getFolders$Json.PATH = '/folder/search';
